// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7ZM3.5 19C3.5 16.2386 5.73858 14 8.5 14H15.5C18.2614 14 20.5 16.2386 20.5 19V21C13.2302 21 7.37302 21 3.5 21V19Z"}}]};

const User1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-1-filled',
    ref,
    icon: element,
  },
));

User1FilledIcon.displayName = 'User1FilledIcon';

export default User1FilledIcon;
